import {
  GroundSelectors,
  useCarDateRange,
  getVehicleClassLabelFromVehicle,
  useCarsStyles,
  CoreCarsComponent,
} from "@apac/components/cars";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useCheckoutStateSelector } from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import defaultStyles from "./styles.module.scss";

export const BasePriceBreakdown = ({
  fiatFormatOptions,
}: {
  fiatFormatOptions?: Intl.NumberFormatOptions;
}) => {
  const COMPONENT_KEY = CoreCarsComponent.BasePriceBreakdown;
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, "BasePriceBreakdown");
  const { t, formatFiatCurrency } = useI18nContext();

  const { dateFormattedString, numDays } = useCarDateRange();

  const { payNowTotal, carPrice, taxesAndFees } = useCheckoutStateSelector(
    GroundSelectors.getCarBreakdownItems
  );

  const { vehicle } = useCheckoutStateSelector(
    GroundSelectors.getSelectedVehicleAvailability
  );

  const rentalInfoLabel = t("apac.cars.priceBreakdown.rentalInfoLabel", {
    count: numDays,
    vehicleCategory: getVehicleClassLabelFromVehicle(t, vehicle),
    // vehicle category translations may have "/" in it
    interpolation: { escapeValue: false },
  });

  return (
    <div className={block}>
      <div className={cn("item-line")}>
        <div className={cn("label", ["info"])}>
          <span className={cn("car-info")}>{rentalInfoLabel}</span>
          <span className={cn("date-info")}>{`(${dateFormattedString})`}</span>
        </div>
        <div className={cn("value")}>
          {formatFiatCurrency(carPrice, fiatFormatOptions)}
        </div>
      </div>

      <div className={cn("item-line", ["tax"])}>
        <div className={cn("label")}>{t("taxesAndFees")}</div>
        <div className={cn("value")}>
          {formatFiatCurrency(taxesAndFees, fiatFormatOptions)}
        </div>
      </div>
      <div className={cn("divider")} />

      <div className={cn("item-line", ["total"])}>
        <div className={cn("label")}>{t("total")}</div>
        <div className={cn("value")}>
          {formatFiatCurrency(payNowTotal?.fiat, fiatFormatOptions)}
        </div>
      </div>
    </div>
  );
};
